'use client';

import React from 'react';
import { ChevronLeft } from 'lucide-react';
import { Step } from '../../chat/types/base_step';
import loadByQuestionType from './load_question';
import Jornaya from '../jornaya';
import TrustedForm from '../trustedform';

interface QuestionAnswers {
  attributeName: string;
  value: any;
}

interface QuestionProps {
  readonly currentStep: Step;
  readonly stepPercentage: number;
  readonly onClickBack: () => void;
  readonly onSubmit: (answers: QuestionAnswers[]) => void;
  readonly answers: Record<string, any>;
  readonly isStartSubmitted: boolean;
}

export default function Question({
  currentStep,
  stepPercentage,
  onClickBack,
  onSubmit,
  answers,
  isStartSubmitted,
}: QuestionProps) {
  const handleSubmit = (questionAnswers: QuestionAnswers[]) => {
    onSubmit(questionAnswers);
  };

  return (
    <div className="max-w-md mx-auto p-1 sm:p-1 h-[460px] sm:h-[440px] overflow-y-auto">
      <Jornaya />
      <TrustedForm />
      <div className="h-2 w-full bg-gray-200 rounded-full mb-2">
        <div
          className="h-full bg-emerald-600 rounded-full transition-all duration-300"
          style={{ width: `${stepPercentage}%` }}
        ></div>
      </div>

      <button
        type="button"
        onClick={onClickBack}
        className="text-xs sm:text-sm flex items-center text-emerald-600 mb-2"
      >
        <ChevronLeft className="h-5 w-5" />
        <span>Back</span>
      </button>

      <h2 className="text-xl sm:text-xl font-medium text-gray-800 mb-2">
        {currentStep.title}
      </h2>
      {loadByQuestionType(currentStep, handleSubmit, answers, isStartSubmitted)}
    </div>
  );
}
